<div class="input-group">
    <input id="typeahead-focus" type="text" class="form-control search-ecommerce"
        [ngbTypeahead]="search" (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)" #instance="ngbTypeahead"
        placeholder="¿Qué vehículo buscas?" [(ngModel)]="model" (keyup)="onKey($event)"/>
    <div class="input-group-append">
      <button class="btn-search" (click)="linkSearch()" type="button"><img src="../../../assets/icons/loupe.svg" class="search-loupe"/></button>
    </div>
</div>
